import { TagGroups } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';

/**
 * Add tag to the target array if it does not already exist
 * @param event
 * @param targetArray
 */
export function addTagToArray(event: AnyType, targetArray: string[]) {
  const tagToAdd = event.name || event;
  if (!targetArray.includes(tagToAdd)) {
    targetArray.push(tagToAdd);
  }
}

/**
 * Deduplicate tags in the target array
 * @param targetArray
 */
export function deduplicateTags(targetArray: string[]) {
  const uniqueSet = new Set(targetArray);
  targetArray.length = 0;
  targetArray.push(...uniqueSet);
}

/**
 * Extract IDs from a nested tag group array structure
 * @param groupArray
 * @param targetId
 * @returns
 */
export function extractIdsFromTagGroup(groupArray: TagGroups): string[] {
  const { groups } = groupArray as AnyType;
  const idsToResolve = new Set<string>();

  // Collect all IDs that need to be resolved
  for (const row in groups) {
    for (const col in groups[row]) {
      const ids = groups[row][col];
      if (Array.isArray(ids)) {
        ids.forEach((id) => idsToResolve.add(id));
      }
    }
  }

  return Array.from(idsToResolve);
}
